import { BRAND_CONFIG } from '@@brand'
import { OfflinePurchasePosition } from '@@types'
import { useTranslation } from 'react-i18next'


import ImageWithBg from '@shared/ui/image-with-bg'
import { formatPrice } from '@shared/uttils'

import styles from './styles.module.scss'

interface OfflineOrderItemProps {
  data: OfflinePurchasePosition
}

export default function OfflineOrderItem ({ data }: OfflineOrderItemProps) {
  const { t: tc } = useTranslation('common')

  const isWeightProduct = data?.product?.price_type === 'weight'
  const unitKey = isWeightProduct ? 'weight.kg' : 'weight.pc'

  return (
    <div key={data?.id} className={styles.orderItem}>
      <ImageWithBg
        className={styles['orderItem__img']}
        src={data?.product?.preview?.url ?? BRAND_CONFIG.images.productPlaceholder}
      />
      <p className={styles['orderItem__text']}>{data?.name}</p>
      <span className={styles['orderItem__description']}>
        {data?.count} {tc(unitKey)}
      </span>
      <div className={styles['orderItem__price']}>
        <span className={styles['orderItem__price-current']}>
          {formatPrice(data?.total ?? 0)}
        </span>
        <span className={styles['orderItem__price-perUnit']}>
          {formatPrice(data?.price ?? 0)} / {tc(unitKey)}
        </span>
      </div>
    </div>
  )
}